/**
 * Type-narrowing coercion helpers.
 *
 * Used to safely render `unknown` values (CSV cells, JWT claims, dynamic
 * keyed lookups) without producing the default '[object Object]' fallback
 * that Object.prototype.toString gives for non-primitives.
 */

/** Coerce a primitive value to its string form; returns '' for non-primitives. */
export function toCellString(v: unknown): string {
    if (typeof v === 'string') {
        return v;
    }
    if (typeof v === 'number' || typeof v === 'boolean') {
        return String(v);
    }
    return '';
}
